import { render, staticRenderFns } from "./widgetRadar.vue?vue&type=template&id=fa8310a2&scoped=true&"
import script from "./widgetRadar.vue?vue&type=script&lang=js&"
export * from "./widgetRadar.vue?vue&type=script&lang=js&"
import style0 from "./widgetRadar.vue?vue&type=style&index=0&id=fa8310a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8310a2",
  null
  
)

export default component.exports